/* eslint-disable no-underscore-dangle */
import {
  BatteryChargingFull,
  Build,
  FlashOn,
  Map,
  PinDrop,
  Satellite,
  SignalCellularAlt,
  Snooze,
  Speed,
  VpnKey,
} from '@material-ui/icons';
import { AddressGoogleMapsLink } from 'components/RenderCustomValues/AddressGoogleMapsLink';
import { BatteryPercent } from 'components/RenderCustomValues/BatteryPercent';
import { BatteryVoltage } from 'components/RenderCustomValues/BatteryVoltage';
import { GsmSignalIcon } from 'components/RenderCustomValues/GsmSignal';
import { IsLocked } from 'components/RenderCustomValues/IsLocked';
import { IsOn } from 'components/RenderCustomValues/IsOn';
import { LastCommunicationTime } from 'components/RenderCustomValues/LastCommunicationTime/index.js';
import { SatelliteSignal } from 'components/RenderCustomValues/SatelliteSignal/index.js';
import { SpeedKmh } from 'components/RenderCustomValues/Speed/index.js';
import { TreatmentGrid } from 'components/RenderCustomValues/Treatments';
import { DiagnosticTreatment } from 'components/RenderCustomValues/DiagnosticTreatment/index';
import { ExpectedNormalizationDate } from 'components/RenderCustomValues/DateTimeFormat/ExpectedNormalizationDate.js';
import { DateTimeFormat } from '../../components/RenderCustomValues/DateTimeFormat/index.js';
import { LatLonFormat } from '../../components/RenderCustomValues/LatLngFormat';
import { MaintenanceDateFormat } from './MaintenanceDateFormat';

export const communicationGridColumns = [
  {
    id: 1,
    label: 'Id_Dispositivo',
    value: 'deviceId',
    // minWidth: 50,
    align: 'center',
    alignRow: 'center',
    default: true,
    name: 'device_id',
  },
  {
    id: 2,
    label: 'Fabricante',
    value: 'manufacturer',
    // minWidth: 50,
    align: 'center',
    alignRow: 'center',
    default: true,
    name: 'manufacturer',
  },
  {
    id: 3,
    label: 'Cliente',
    value: 'name',
    // minWidth: 50,
    align: 'center',
    default: true,
    name: 'client',
  },
  {
    id: 4,
    label: 'Placa',
    value: 'plate',
    align: 'center',
    alignRow: 'center',
    default: true,
    name: 'plate',
    // minWidth: 100,
  },
  {
    id: 6,
    label: 'Data Sistema',
    value: 'dateSystem',
    // minWidth: 140,
    align: 'center',
    alignRow: 'center',
    default: true,
    name: 'date_system',
    render: ({ dateSystem }: { dateSystem: string }) => (
      <DateTimeFormat date={dateSystem} />
    ),
  },
  {
    id: 22,
    label: 'Status',
    value: 'status',
    // minWidth: 140,
    align: 'center',
    alignRow: 'center',
    default: true,
    name: 'maintenance',
    description: '',
    render: ({ status }: { status: string }) => (
      <DiagnosticTreatment status={status} />
    ),
  },
  {
    id: 23,
    label: 'Tempo em manutenção',
    value: 'maintenanceDate',
    align: 'center',
    alignRow: 'center',
    default: true,
    name: 'maintenanceDate',
    description: '',
    render: ({
      maintenanceDate,
    }: {
      maintenanceDate: Date | null | undefined;
    }) => (
      <MaintenanceDateFormat
        dateTime={maintenanceDate ? new Date(maintenanceDate) : null}
      />
    ),
  },
  {
    id: 21,
    label: 'Tratamento',
    value: 'treatment',
    default: true,
    name: 'treatment',
    description: '',
    align: 'center',
    alignRow: 'center',
    icon: <Build fontSize="inherit" style={{ fontSize: 15 }} />,
    render: ({ vehicleId }: { vehicleId: string }) => (
      <TreatmentGrid vehicleId={vehicleId} />
    ),
  },

  {
    id: 7,
    label: 'Data GPS',
    value: 'dateTime',
    // minWidth: 140,
    align: 'center',
    alignRow: 'center',
    default: true,
    name: 'date_time',
    render: ({ dateTime }: { dateTime: string }) => (
      <DateTimeFormat date={dateTime} />
    ),
  },
  {
    id: 5,
    label: 'Tempo sem comunicar',
    default: true,
    value: 'dateSystem',
    name: 'date_system_count',
    minWidth: 140,
    align: 'center',
    alignRow: 'center',
    icon: <Snooze style={{ fontSize: 15 }} />,
    render: ({ dateSystem }: { dateSystem: string }) => (
      <LastCommunicationTime dateTime={dateSystem} />
    ),
  },
  {
    id: 8,
    label: 'Latitude',
    value: 'latitude',
    align: 'center',
    alignRow: 'center',
    default: false,
    name: 'latitude',
    render: ({ latitude }: { latitude: string }) => (
      <LatLonFormat coord={latitude} />
    ),
  },
  {
    id: 9,
    label: 'Longitude',
    value: 'longitude',
    align: 'center',
    alignRow: 'center',
    default: false,
    name: 'longitude',
    render: ({ longitude }: { longitude: string }) => (
      <LatLonFormat coord={longitude} />
    ),
  },
  {
    id: 10,
    label: 'Abrir no google maps',
    default: true,
    value: 'longitude',
    name: 'google_maps',
    minWidth: 50,
    align: 'center',
    alignRow: 'center',
    icon: <Map style={{ fontSize: 15 }} />,
    render: ({
      longitude,
      latitude,
    }: {
      longitude: string;
      latitude: string;
    }) => (
      <AddressGoogleMapsLink
        lat={latitude}
        lng={longitude}
        label={<PinDrop style={{ fontSize: 15 }} />}
      />
    ),
  },
  {
    id: 11,
    label: 'GPS satelite',
    value: 'satellite',
    align: 'center',
    alignRow: 'center',
    default: true,
    name: 'satellite',
    icon: <Satellite fontSize="inherit" style={{ fontSize: 15 }} />,
    render: ({ satellite }: { satellite: string }) => (
      <SatelliteSignal signal={satellite} />
    ),
  },
  {
    id: 12,
    label: 'GPRS',
    value: 'signal',
    align: 'center',
    alignRow: 'center',
    default: true,
    name: 'signal',
    icon: <SignalCellularAlt fontSize="inherit" style={{ fontSize: 15 }} />,
    render: ({
      signal,
      manufacturer,
    }: {
      signal: string;
      manufacturer: string;
    }) => <GsmSignalIcon signal={signal} manufacturer={manufacturer} />,
  },
  {
    id: 13,
    label: 'Ignição',
    value: 'ignition',
    align: 'center',
    alignRow: 'center',
    default: true,
    name: 'ignition',
    icon: <VpnKey fontSize="inherit" style={{ fontSize: 15 }} />,
    render: ({ ignition }: { ignition: boolean }) => <IsOn isOn={ignition} />,
  },
  {
    id: 14,
    label: 'Velocidade',
    value: 'speed',
    align: 'center',
    alignRow: 'center',
    default: true,
    name: 'speed',
    // minWidth: 100,
    icon: <Speed fontSize="inherit" style={{ fontSize: 15 }} />,
    render: ({ speed }: { speed: string }) => <SpeedKmh speed={speed} />,
  },
  {
    id: 15,
    label: 'Voltagem',
    value: 'voltage',
    align: 'center',
    default: true,
    name: 'voltage',
    alignRow: 'center',
    icon: <FlashOn fontSize="inherit" style={{ fontSize: 15 }} />,
    render: ({ voltage }: { voltage: string }) => (
      <BatteryVoltage voltage={voltage} />
    ),
  },
  {
    id: 16,
    label: 'Bateria',
    value: 'bateryPercent',
    align: 'center',
    alignRow: 'center',
    default: true,
    name: 'batery_percent',
    icon: <BatteryChargingFull fontSize="inherit" style={{ fontSize: 15 }} />,
    render: ({
      bateryPercent,
      manufacturer,
    }: {
      bateryPercent: string;
      manufacturer: string;
    }) => (
      <BatteryPercent
        batteryPercent={bateryPercent}
        manufacturer={manufacturer}
      />
    ),
  },
  {
    id: 17,
    label: 'S1',
    value: 'out1',
    align: 'center',
    alignRow: 'center',
    default: true,
    name: 'out1',
    render: ({
      out1,
      model,
    }: {
      out1: boolean;
      manufacturer: string;
      model: string;
    }) => <IsLocked isOn={out1} model={model} />,
  },

  // {
  //   id: 18,
  //   label: 'S2',
  //   value: 'out2',
  //   align: 'center',
  //   alignRow: 'center',
  //   default: false,
  //   name: 'out2',
  //   render: ({ out2, model }: { out2: boolean; model: string }) => (
  //     <IsLocked isOn={out2} model={model} />
  //   ),
  // },
  {
    id: 24,
    label: 'Data inicial de tratamento',
    value: 'firstDiagnosis',
    align: 'center',
    alignRow: 'center',
    default: true,
    name: 'first_diagnosis',
    description: '',
    render: ({ firstDiagnosis }: { firstDiagnosis: string }) => (
      <DateTimeFormat date={firstDiagnosis} />
    ),
  },
  {
    id: 25,
    label: 'Data final de tratamento',
    value: 'lastDiagnosis',
    align: 'center',
    alignRow: 'center',
    default: true,
    name: 'last_diagnosis',
    description: '',
    render: ({ lastDiagnosis }: { lastDiagnosis: string }) => (
      <DateTimeFormat date={lastDiagnosis} />
    ),
  },

  {
    id: 26,
    label: 'Data de normalização esperada',
    value: 'expectedNormalizationDate',
    align: 'center',
    alignRow: 'center',
    default: true,
    name: 'expected_normalization_date',
    description: '',
    render: ({
      expectedNormalizationDate,
    }: {
      expectedNormalizationDate: string;
    }) => (
      <ExpectedNormalizationDate date={expectedNormalizationDate} dateOnly />
    ),
  },
];

// TELA DE DIAGNOSTICO!
